<template>

    <div v-if="dataStore.showFindPlace" id="find-place" class="general-popup">

        <div class="wrapper">

            <span class="close-popup" v-on:click.prevent="globalFunctions.toggleFindPlace"><i class="fas fa-times"></i></span>

            <div class="form-group-wrap">

                <input v-model="placeToSearch" type="text" class="form-control" id="search-place" :placeholder="language.search">

                <button class="btn btn-primary" v-on:click.prevent="searchPlace">{{ language.find_place_search }}</button>

            </div>

            <div class="find-place-map">

                <MglMap
                    :ref="'findplace'"
                    :mapboxGl="mapboxgl"
                    :mapStyle.sync="mapBoxSettings.mapStyle"
                    :accessToken="mapBoxSettings.accessToken"
                    @load="onMapLoaded"
                    :center="dataStore.project.addressMapCenter ? [ parseFloat(dataStore.project.addressMapCenter.lng), parseFloat(dataStore.project.addressMapCenter.lat)  ] : [ 14.6938511, 59.1232223 ]"
                    :zoom="dataStore.project.addressZoom"
                    :minZoom="5"
                >
                    <MglNavigationControl position="bottom-right"/>

                    <img id="pin-find-me" :src="'/images/google_map_pin.png'" />

                </MglMap>

            </div>

            <div class="form-group-wrap bottom">
                <button class="btn btn-primary" v-on:click.prevent="savePlace">{{ language.save }}</button>
            </div>

        </div>

    </div>

</template>

<script>

import dataStore from '../../store'

import globalFunctions from '../../globalFunctions'

import mapboxgl from 'mapbox-gl'

import { MglMap, MglNavigationControl } from 'vue-mapbox'

import mapBoxSettings from './../../../mapbox-settings'

export default {

    components: {

        MglMap,

        MglNavigationControl

    },

    data() {

        return {

            dataStore,

            globalFunctions,

            placeToSearch : '',

            mapboxgl,

            mapBoxSettings,

            mapbox : null,

            map : null

        }

    },

    inject: [ 'language' ],

    methods : {

        onMapLoaded: function(event) {

            this.mapbox = event.component.mapbox

            this.map = event.map

            this.map.on('zoomend', () => this.zoom_changed() )

            this.map.on('dragend', () => this.dragendMap() )

        },

        dragendMap: function() {
            this.dataStore.project.addressMapCenter = this.map.getCenter()
        },

        zoom_changed: function() {

            this.dataStore.project.addressZoom = this.map.getZoom()

            this.dataStore.project.addressMapCenter = this.map.getCenter()

        },

        updateLink: function() {

            if( this.dataStore.project.addressMapCenter === null ) {

                this.dataStore.project.addressZoom = this.map.getZoom()

                this.dataStore.project.addressMapCenter = this.map.getCenter()

            }

            this.dataStore.project.address =  JSON.stringify( this.dataStore.project.addressMapCenter.lat + ',' + this.dataStore.project.addressMapCenter.lng + ',' + this.dataStore.project.addressZoom );
            // this.dataStore.project.mapLink = `https://www.google.se/maps/@${this.dataStore.project.addressMapCenterLat},${this.dataStore.project.addressMapCenterLng},${this.dataStore.project.addressZoom}z`;

            // https://www.google.com/maps/search/?api=1&query=13.0106708,77.5552532
            this.dataStore.project.mapLink = `https://www.google.com/maps/search/?api=1&query=${this.dataStore.project.addressMapCenter.lat},${this.dataStore.project.addressMapCenter.lng}`

            this.showCoordinates = true;

        },

        searchPlace: function() {

            // https://docs.mapbox.com/playground/geocoding/

            axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${this.placeToSearch}.json?country=se&limit=1&types=place&language=sv&access_token=${this.mapBoxSettings.accessToken}`)

            .then(response => {

                const { status, data } = response

                if( status === 200 && data.features.length ) {

                    const result = data.features[0]

                    this.dataStore.project.addressMapCenter = {
                        lng : result.center[0],
                        lat : result.center[1],
                    }

                }

            })

        },

        closeMe: function(e) {

            if( e.target.classList.contains('general-popup') ) {

                this.dataStore.showFindPlace = false

            }

        },

        savePlace: function() {

            this.updateLink();

            this.dataStore.showFindPlace = false;

        }

    }
}

</script>
